/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProjectEntitlementsAndiChat } from './ProjectEntitlementsAndiChat';
import {
    ProjectEntitlementsAndiChatFromJSON,
    ProjectEntitlementsAndiChatFromJSONTyped,
    ProjectEntitlementsAndiChatToJSON,
} from './ProjectEntitlementsAndiChat';
import type { ProjectEntitlementsBrandingRemoval } from './ProjectEntitlementsBrandingRemoval';
import {
    ProjectEntitlementsBrandingRemovalFromJSON,
    ProjectEntitlementsBrandingRemovalFromJSONTyped,
    ProjectEntitlementsBrandingRemovalToJSON,
} from './ProjectEntitlementsBrandingRemoval';
import type { ProjectEntitlementsLogRetentionDays } from './ProjectEntitlementsLogRetentionDays';
import {
    ProjectEntitlementsLogRetentionDaysFromJSON,
    ProjectEntitlementsLogRetentionDaysFromJSONTyped,
    ProjectEntitlementsLogRetentionDaysToJSON,
} from './ProjectEntitlementsLogRetentionDays';

/**
 * Plan-based feature flags for the project. These are managed by Ampersand and cannot be set via the API.
 * @export
 * @interface ProjectEntitlements
 */
export interface ProjectEntitlements {
    /**
     * 
     * @type {ProjectEntitlementsBrandingRemoval}
     * @memberof ProjectEntitlements
     */
    brandingRemoval?: ProjectEntitlementsBrandingRemoval;
    /**
     * 
     * @type {ProjectEntitlementsLogRetentionDays}
     * @memberof ProjectEntitlements
     */
    logRetentionDays?: ProjectEntitlementsLogRetentionDays;
    /**
     * 
     * @type {ProjectEntitlementsAndiChat}
     * @memberof ProjectEntitlements
     */
    andiChat?: ProjectEntitlementsAndiChat;
}

/**
 * Check if a given object implements the ProjectEntitlements interface.
 */
export function instanceOfProjectEntitlements(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProjectEntitlementsFromJSON(json: any): ProjectEntitlements {
    return ProjectEntitlementsFromJSONTyped(json, false);
}

export function ProjectEntitlementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectEntitlements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandingRemoval': !exists(json, 'brandingRemoval') ? undefined : ProjectEntitlementsBrandingRemovalFromJSON(json['brandingRemoval']),
        'logRetentionDays': !exists(json, 'logRetentionDays') ? undefined : ProjectEntitlementsLogRetentionDaysFromJSON(json['logRetentionDays']),
        'andiChat': !exists(json, 'andiChat') ? undefined : ProjectEntitlementsAndiChatFromJSON(json['andiChat']),
    };
}

export function ProjectEntitlementsToJSON(value?: ProjectEntitlements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandingRemoval': ProjectEntitlementsBrandingRemovalToJSON(value.brandingRemoval),
        'logRetentionDays': ProjectEntitlementsLogRetentionDaysToJSON(value.logRetentionDays),
        'andiChat': ProjectEntitlementsAndiChatToJSON(value.andiChat),
    };
}

